/**
 * Styled Components - Created by cazarez on 07/02/18.
 */
import styled from 'styled-components'
import Dropdown from 'antd/lib/dropdown'
import { GRAY } from '../../theme/colors'

export const Container = styled.div`
  color: var(--neutral-secondary);
  display: flex;
  flex-flow: column;
  gap: var(--spacing-24);

  @media (max-width: 698px) {
    gap: 10px;
    margin-bottom: var(--spacing-24);
    padding-bottom: var(--spacing-24);
    border-bottom: var(--border-regular) solid var(--neutral-secondary);
  }
`
export const Logo = styled.img`
  max-width: 90px;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const AddressText = styled.div`
  font-weight: 400;
`

export const DropdownStyled = styled(Dropdown)`
  display: flex;
  align-items: center;
  border: 1px solid #686868;
  width: fit-content;
  padding: 4px 8px;
  border-radius: 3px;
  @media (max-width: 698px) {
    position: absolute;
    top: -10px;
    right: 0;
  }
`

export const Option = styled.div`
  display: flex;
  align-items: center;
`

export const MenuOption = styled.div`
  color: #5f6062;
  margin-left: 12px;
  font-size: 14px;
  line-height: 22px;
`

export const FlagIconButton = styled.img`
  max-width: 22px;
  border-radius: 3px;
  &:hover { 
    cursor: pointer;
  }
`

export const CurrencyDiv = styled.div`
  display: flex;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`

export const LinkLabel = styled.a`
  text-decoration: underline;
  color: var(--neutral-muted);
  &:hover {
    color: #fff;
    text-decoration: underline;
  }
`

export const Subtitle = styled.div`
  font-size: 11.5px;
  color: ${GRAY};
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ContactInfo/styledComponents.tsx